'use client';

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif',
      background: '#fafafa', color: '#1a1a2e',
    }}>
      <div style={{ textAlign: 'center', maxWidth: 400, padding: 32 }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>⚡</div>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>Something went wrong</h1>
        <p style={{ color: '#666', fontSize: 14, lineHeight: 1.6, marginBottom: 24 }}>
          We&apos;re sorry. An unexpected error occurred. Please try again or contact support if the issue persists.
        </p>
        <button
          onClick={reset}
          style={{
            padding: '12px 32px', background: '#D4A017', color: '#fff', border: 'none',
            borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer',
          }}
        >
          Try Again
        </button>
        <p style={{ fontSize: 12, color: '#aaa', marginTop: 16 }}>
          Error: {error.message || 'Unknown'}
        </p>
      </div>
    </div>
  );
}
